var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"List"},[_c('div',{staticClass:"List__title"},[_vm._v("Page List")]),_c('ul',{staticClass:"List__list"},_vm._l((_vm.pageList),function(page){return _c('li',{staticClass:"List__item"},[_c('a',{attrs:{"href":page.url}},[_c('div',{staticClass:"List__item__title"},[_vm._v(_vm._s(page.name))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }